"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.populateVote = void 0;
function populateVote(member, allNominationIds, defaultExcluded = false) {
    const allNominationIdsSet = new Set(allNominationIds);
    const legitimateVoteItems = [];
    for (let voteItem of member.vote) {
        if (allNominationIdsSet.has(voteItem.nominationId)) {
            legitimateVoteItems.push(voteItem);
        }
    }
    member.vote = legitimateVoteItems;
    const votedNominationIds = new Set(member.vote.map(voteItem => voteItem.nominationId));
    const newVoteItems = [];
    for (let nominationId of allNominationIds) {
        if (!votedNominationIds.has(nominationId)) {
            newVoteItems.unshift({
                nominationId: nominationId,
                excluded: defaultExcluded,
                vetoed: false
            });
        }
    }
    member.vote.unshift(...newVoteItems);
}
exports.populateVote = populateVote;
//# sourceMappingURL=member.dto.js.map